// Defense-in-depth scheme allowlist for any URL rendered as <a href>.
// The backend now rejects non-http(s) schemes (F-INPUT-01), but historical
// rows written before that fix may still contain `javascript:` / `data:` /
// `vbscript:` / `file:` URLs. Returning `undefined` for those collapses the
// anchor to a no-op rather than navigating to an attacker-controlled sink.
export function safeHref(url) {
  if (!url || typeof url !== "string") return undefined;
  try {
    const u = new URL(url);
    return u.protocol === "http:" || u.protocol === "https:"
      ? u.toString()
      : undefined;
  } catch {
    return undefined;
  }
}
